import { advancedSearchQueryKeyFactory } from "../queryKeyFactory";

import type { IAdvancedSearchQueryClient, IAdvancedSearchQueryClientDeps } from "./types";

export const createAdvancedSearchQueryClient = ({
    queryClient,
}: IAdvancedSearchQueryClientDeps): IAdvancedSearchQueryClient => {
    const invalidateLeadsSearchResultsQueries = (): Promise<void> => {
        return queryClient.invalidateQueries({
            queryKey: advancedSearchQueryKeyFactory.tableData(),
            refetchType: "all",
        });
    };

    return {
        invalidateLeadsSearchResultsQueries,
    };
};
